import { createDataForWriteBackTrail } from "../../../../components/modals/imageViewerWithBadgesModal/utils/createDataForWriteBackTrail";
import { AuthStatusOptionModel } from "../../../../data-model/authStatusOptions";
import { ModalId } from "../../../../enums/modalId";
import {
  setMetaData,
  setOpenedModalId,
} from "../../../../redux/slice/modalSlice";
import { AppDispatch } from "../../../../redux/store/store";

export const handleRpaStatusScreenshotViewForMyPaOrders = async (
  id: string,
  dispatch: AppDispatch,
  authStatusOptions: AuthStatusOptionModel[],
) => {
  try {
    dispatch(
      setOpenedModalId({
        id: ModalId.IMAGE_VIEWER_WITH_BADGES_MODAL,
        metaData: {
          showLoading: true,
        },
      }),
    );
    const dataForWriteBackTrail = await createDataForWriteBackTrail(
      id,
      authStatusOptions,
    );
    dispatch(
      setMetaData({
        tabs: dataForWriteBackTrail.tabs,
        showLoading: false,
      }),
    );
  } catch (error) {
    dispatch(
      setMetaData({
        tabs: [],
        showLoading: false,
      }),
    );
  }
};
